<template>
    <section class="characteristics_section">
        <!-- <img
            src="@/assets/background/Line_3.svg"
            class="line_3"
        /> -->
        <!-- <img
            src="@/assets/background/Triangles_4.png"
            class="Triangles_4"
        />
        <img
            src="@/assets/background/Triangles_4_mob.png"
            class="Triangles_4_mob"
        /> -->
        <h3 class="characteristics_title text_align_center">
            Характеристика ЛК
        </h3>

        <div class="characteristics_container">
            <div class="characteristics_box_in_box">
                <div class="characteristics_box_1">
                    <div class="characteristics_box_360">
                        <div class="characteristics_box">
                            <p class="characteristics_360_text">
                                655
                            </p>
                            <p class="characteristics_360_subtext">
                                видеокамер
                            </p>
                        </div>
                    </div>
                    <div class="characteristics_indentation_box">
                        <p class="characteristics_indentation_text text_align_right">
                            Пожаро-охранная сигнализация. Круглосуточная охрана на территории.
                        </p>
                    </div>
                </div>
                <div class="characteristics_box_2">
                    <div>
                        <p class="characteristics_s text_align_center">
                            S
                        </p>
                        <p class="characteristics_title_meter text_align_center">
                            33000 м&#178;
                        </p>
                    </div>
                    <div class="characteristics_text_margin">
                        <p class="characteristics_indentation_text text_align_center">
                            Ёмкость хранения
                            более  <span class="characteristics_title_meter text_align_center">
                                50 000
                            </span>
                            п.м.<br />
                            <span class="characteristics_title_meter text_align_center">
                                11 500 ячеек<br />
                            </span>

                            полочного хранения
                        </p>
                    </div>
                    <div>
                        <p class="characteristics_title_meter text_align_center">
                            56 ед.
                        </p>
                        <p class="characteristics_indentation_text text_align_center">
                            ворот с докшелтерами, доклевеллерами и тепловыми завесами
                        </p>
                    </div>
                </div>
            </div>
            <div class="characteristics_box_in_box_2">
                <div class="characteristics_box_3">
                    <p class="characteristics_indentation_text text_align_left">
                        Логистический комплекс оснащён системой контроля и управление доступом. Управление двором - диспечеризация прибывших и отгруженных ТС.
                    </p>
                </div>
                <div class="characteristics_box_4">
                    <div class="characteristics_stock_box">
                        <p class="characteristics_indentation_text text_align_left letter-spacing-1">
                            Собственный автопарк.
                        </p>

                    </div>
                    <p class="characteristics_indentation_subtext text_align_right">
                        Общая численность ТС грузоподъемностью от 1,5 до 24 тонн - более<span class="characteristics_indentation_text"> 200 ЕДИНИЦ.</span>
                    </p>
                </div>
                <div class="characteristics_box_5">
                    <p class="characteristics_indentation_subtext_box5">
                        Мультитемпературный склад. 7 температурных зон с температурой хранения от -25 до +21 градусов.<br />

                        Система «климатконтроля» (воздушное отопление, рекуперация, фанкойлы).
                    </p>
                </div>
                <div class="characteristics_box_6">
                    <p class="characteristics_indentation_text text_align_right letter-spacing-1">
                        ПРОИЗВОДСТВЕННЫЙ УЧАСТОК
                    </p>
                    <!-- <p class="characteristics_indentation_subtext text_align_right">
                        С учётом наличия спецификации и необходимых требований выполняется комплекс дополнительных услуг
                    </p> -->
                    <p class="characteristics_indentation_subtext text_align_right">
                        <!-- · Приемка/Отгрузка ЖД поставок<br /> -->
                        · Переупаковка/миксование по заданию<br />
                        · Фасовка товаров<br /> по спецификации клиента<br />
                        · Маркировка/стикеровка<br /> штук, коробов, паллет<br />
                        · Переборка<br />
                        · Подготовка заказов к отгрузке на маркетплейсы Ozon, Wildberries. и прочее<br />
                    </p>
                </div>
                <div class="characteristics_box_7">
                    <p class="characteristics_s text_align_center">
                        КЛАСС А+
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'CharacteristicsSection',
};
</script>

<style scoped>
.Triangles_4{
position: absolute;
width: 43.75rem;
height: 74.79rem;
z-index: -2;
left: 0px;
top: -27rem;
}
.Triangles_4_mob{
    display: none;
}
@media (max-width: 767px) {
.Triangles_4{
    display: none;
}
.Triangles_4_mob{
    display: block;
     width: 20rem;
    height: 36.94rem;
    position: absolute;
    z-index: -1;
    right: 0px;
    top: -6.5rem;
}
}
</style>
